import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import * as fromActions from './init-user.actions';
import { map } from 'rxjs/operators';
import { UserModel } from '@app/models/server/user.model';
import { InitAuthService } from '@app/services/global-services/auth/init-auth-service';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { environment } from '@src/environments/environment';

@Injectable()
export class InitUserEffects {
  init: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(fromActions.INIT),
      switchMap((action: {}) => {
        return this.initAuthService.getAuthToken().pipe(
          map((authToken: string) => {
            // LoggerService.log('user effect init authToken is ', authToken);
            if (authToken) {
              if (!this.initAuthService.isTokenExpired(authToken)) {
                /*LoggerService.log(
                  'user effect init 1 authToken is ',
                  authToken
                );*/
                const user: UserModel =
                  this.initAuthService.getUserFromToken(authToken);
                // LoggerService.log('user is ', user);
                /* LoggerService.log('user effect init 2 user is ', user);*/
                if (user) {
                  if (environment.mobileApp) {
                    this.eventService.userLoggedInEvent.emit({
                      authToken,
                      fromState: 'INIT_USER_STATE',
                    });
                  }
                  return fromActions.InitAuthorized({
                    user,
                    _id: user._id,
                  });
                } else {
                  return fromActions.InitUnAuthorized({});
                }
              } else {
                // LoggerService.warn('Token is expired');
                return fromActions.InitUnAuthorized({});
              }
            } else {
              return fromActions.InitUnAuthorized({});
            }
          }),
          /*catchError((error: any) => {
            return this.handleLoginError(error, null, false);
          })*/
        );
      }),
    ),
  );

  signOut: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(fromActions.SignOut),
      switchMap((action: {}) => {
        return of(fromActions.SignOutSuccess({}));
      }),
    ),
  );

  constructor(
    private actions: Actions,
    private initAuthService: InitAuthService,
    private eventService: EventService,
  ) {}

  /*  handleLoginError(
      error: any,
      email: string,
      disablePageNavigation: boolean
    ): Observable<
      { error: string } & TypedAction<fromActions.Types.SIGN_IN_ERROR>
      > {
      // this.toastService.success('Signin failed');
      this.loadingService.dismiss().then();
      LoggerService.log('user effect catcherror error is ', error);

      let errorMessage: string;
      if (error.code) {
        errorMessage = this.handleFirebaseError(
          error.code,
          disablePageNavigation
        );
      } else {
        errorMessage = this.toastService.showApiError(error);
      }

      return of(
        fromActions.SignInEmailError({
          error: errorMessage,
          email,
        })
      );
    }*/
}
